import React from 'react'
import { formatProductReviewStatusLabel } from '@@partner:helpers/formatters/productReview'

import { Tag } from 'rsuite'

export interface ProductReviewStatusLabelProps {
  status: number
}

export default function ProductReviewStatusLabel ({
  status
}: ProductReviewStatusLabelProps) {
  const { label, color = null } = formatProductReviewStatusLabel(status)
  return <Tag color={color}>{label}</Tag>
}
